export default {
  'en': {
    'common.and': 'and',
    'common.bid': 'bid',
    'common.bids_few': 'bids',
    'common.bids_many': 'bids',
    'common.day': 'day',
    'common.days_few': 'days',
    'common.days_many': 'days',
    'common.foundation_instrumental_case': 'foundation',
    'common.foundations_instrumental_case': 'foundations',
    'common.hour': 'hour',
    'common.hours_few': 'hours',
    'common.hours_many': 'hours',
    'hero.for_charity': 'for charity',
    'hero.good_excuse': 'A good excuse for a meeting and the right way to help! Make bids, win meetings and help those who need it most.',
    'profile_report.report_sent': 'Your report was successfully sent!',
    'profile_report.report_about': 'Report about your meeting with',
    'profile_report.your_impressions': 'Your impressions',
    'profile_report.error': 'Something went wrong, please try again later...',
    'profile_report.send': 'Send',
    'profile_report.delete_photo': 'Delete photo',
    'profile_report.add_photo': 'Add photo',
    'profile_report.you_must_fill': 'You must fill in the text of the report',
    'profile_edit.back': 'BackВве',
    'profile_edit.save': 'Save info',
    'profile_edit.login': 'Change phone number',
    'profile_edit.name': 'Name',
    'profile_edit.surname': 'Surname',
    'profile_edit.field_required': 'The field is not filled in',
    'profile_edit.phone_format': 'Phone number should take the format: 7ХХХХХХХХХХ',
    'profile_edit.email_format': 'Email should take the format: something@example.com',
    'profile_sidebar.you_donated': 'You donated',
    'profile_sidebar.you_did_not_donate': 'You did not<br />donate anything',
    'profile_sidebar.unpaid_lots': 'Unpaid lots',
	'profile_sidebar.paid_fixedpricelots': 'Paid lots',
    'profile_sidebar.pay': 'Pay',
    'profile_sidebar.not_won': 'It seems that you have not yet won a single auction. It is time to make your winning bid and support those who need it most!',
    'claim.become_participant': 'Become a participant',
    'claim.application_accepted': 'Your application has been accepted!',
    'claim.few_words': 'Write a few words about yourself',
    'claim.write_about': 'Write about yourself',
    'claim.send': 'Send',
    'claim.error': 'Something went wrong, try again later...',
    'select.subject': 'Subject of message',
    'header.auctions': 'Auctions',
    'header.fixedprices': 'FixPrice lots',
    'header.help': 'To help',
    'header.foundations': 'Foundations',
    'header.participants': 'Participants',
    'header.news': 'News',
    'header.contacts': 'Contacts',
    'header.become_participant': 'Become a participant',
    'header.settings': 'Settings',
    'header.profile': 'Profile',
    'header.logout': 'Logout',
    'header.login': 'Login',
    'timer.repeat_in': 'We have sent you a confirmation code on your login. You can request another code in',
    'timer.resend': 'Send another code',
    'timer.back': 'Back',
    'sidebar_share.share': 'Share:',
    'sidebar_share.facebook': 'Facebook',
    'sidebar_share.vk': 'VK',
    'sidebar_share.twitter': 'Twitter',
    'form.send': 'Send',
    'preview_list.we_have': 'We have partnerships with',
    'preview_list.among_them': 'among them',
    'preview_list.see_all': 'See all Foundations',
    'bid_history.you': 'You',
    'bid_history.show_more': 'Show more',
    'bid.bid_sent': 'Your bid was successfully entered!',
    'bid.bid_na': 'Bids not available',
    'bid.make_bid': 'Make a bid',
    'bid.make_purchase': 'Make a purchase',
    'bid.login_required': 'First login to your account',
    'bid.bid': 'Bid',
    'bid.error': 'Something went wrong, try again later...',
    'bid.make_bid_anonymously': 'Place a bid anonymously',
    'bid.follow_auction': 'Follow this auction',
    'bid.choose_bid': 'Choose your bid',
    'bid.choose_payment_method': 'Choose your payment method',
    'bid.bid_too_small': 'Your bid cannot be any less than',
    'bid.agreement_title': 'Dear customer!',
    'bid.proceed': 'Continue',
    'bid.select_payment': 'Select payment method',
    'bid.make_payment': 'Make donation',
    'bid.select_card': 'Select card',
    'bidPayment.confirm_delete_card': 'Are you sure you want to delete the linked card?',
    'bidPayment.add': 'Add new card',
    'bidPayment.remove': 'Remove',
    'bidPayment.activated': 'Activated',
    'lot_sidebar.profile': 'Profile',
    'lot_sidebar.on_facebook': 'on Facebook',
    'person.tell_us': 'Tell us about<br />the meeting',
    'person.expiration': 'Until the end of the auction',
    'person.overbid': 'You’ve been overbid',
    'person.leading_bid': 'Your bid is in the lead',
    'person.place_bid': 'Place a bid',
    'contacts_form.message_sent': 'Your message was sent!',
    'contacts_form.write_message': 'Write a message',
    'contacts_form.name': 'Name',
    'contacts_form.email_or_phone': 'Email or telephone',
    'contacts_form.message': 'Message',
    'contacts_form.error': 'Something went wrong, try again later...',
    'preview_list.see_all_news': 'See all news items',
    'fund_donation_container.participants_supported': 'Participants, which have supported the foundation',
    'fund_donation_container.show_more': 'Show more',
    'fund_donation.may_26': 'May 26',
    'fund_donation_stats.amount': 'The amount collected for the foundation is',
    'fund_donation_stats.no_funds': 'No funds have been collected for the foundation yet',
    'mobile_menu.auctions': 'Auctions',
    'mobile_menu.fixedprices': 'FixPrice lots',
    'mobile_menu.help': 'To help',
    'mobile_menu.foundations': 'Foundations',
    'mobile_menu.participants': 'Participants',
    'mobile_menu.news': 'News',
    'mobile_menu.contacts': 'Contacts',
    'mobile_menu.become_participant': 'Become a participant',
    'mobile_menu.settings': 'Settings',
    'mobile_menu.logout': 'Logout',
    'mobile_menu.login': 'Login',
    'payment_fallback.success': 'Lot payment was<br />successfully carried out!',
    'payment_fallback.home': 'To Home Page',
    'payment_fallback.foundation': 'Foundation',
    'payment_fallback.sum': 'Donation sum',
    'payment_callback.heading': 'Heading',
    'payment_callback.email': 'Your email',
    'payment_callback.enter_email': 'Enter your email address',
    'payment_callback.email_format': 'Incorrect format for an email address',
    'payment_form.pay': 'Pay',
    'payment_error.error': 'An error occurred during the execution of your donation',
    'payment_error.try_again': 'Try again',
	'fixedlot.place_order': 'Buy lot',//'Make appointment',
	'fixedlot.expert_text': 'These lots are available at a fixed cost',
    'footer.offer': 'Offer',
    'footer.about': 'About Us',
    'footer.user_agreement': 'User Agreement',
    'footer.auctions': 'Auctions',
    'footer.fixedprices': 'Fix price lots',
    'footer.foundations': 'Foundations',
    'footer.participants': 'Participants',
    'footer.news': 'News',
    'footer.contacts': 'Contacts',
    'footer.partners': 'Partners',
    'footer.we_are_on': 'We are on',
    'footer.facebook': 'Facebook',
    'footer.instagram': 'Instagram',
    'footer.twitter': 'Twitter',
    'footer.youtube': 'YouTube',
    'footer.subscription_success': 'Subscription successful!',
    'footer.subscribe': 'Subscribe to our newsletter',
    'about.about': 'About us',
    'sign_in.login': 'Login',
    'sign_in.phone': 'Telephone',
    'sign_in.mail': ' Email address',
    'sign_in.phone_or_mail': 'Your phone number',
    'sign_in.confirmation_code': 'Confirmation code',
    'sign_in.name': 'Name',
    'sign_in.surname': 'Surname',
    'sign_in.by_pressing': 'By pressing the following, I agree to the conditions',
    'sign_in.user_agreement': 'User Agreement',
    'sign_in.and_give_permission': 'and give permission to the use of my personal information',
    'profile.meet': 'Meet',
    'profile.auctions_won': 'Auctions won',
    'profile.organize_meeting': 'Organize a meeting',
    'profile.tell_about_meeting': 'Tell us about your meeting',
    'profile.meetings': 'Your meetings',
    'profile.win_meeting': 'Win the meeting of your dreams',
    'profile.choose_auction': 'Choose the auction featuring a hero that interests you and place a bid.',
    'profile.see_auctions': 'See auctions',
    'profile.active_auctions': 'Active auctions',
    'profile.bid_history': 'Bid history',
    'static.last_modified': 'Date of last modification',
    'contacts.address': 'Moscow, Novaia Ploshchad, 6',
    'contacts.we_are_on': 'We are on',
    'contacts.facebook': 'Facebook',
    'contacts.instagram': 'Instagram',
    'contacts.twitter': 'Twitter',
    'contacts.youtube': 'YouTube',
    'contacts.if_you_have': 'If you have any questions about the operation of the site, application, auction mechanics, lots or any other issue, write to us:',
    'contacts.write': 'Write',
    'home.see_all_auctions': 'See all auctions',
    'pay.pay': 'Pay',
    'pay.card': 'Pay by card',
    'pay.do_payment': 'Make payment',
    'members.more': 'See more',
    'lot_list_index.loading': 'Loading',
    'lot_list_index.more': 'See more',
    'funds.collected': 'collected',
    'funds.more': 'Show more',
    'lot.last_bid': 'Previous bid',
    'lot.raise_bid': 'Raise the bid',
    'lot.place_bid': 'Place a bid',
    'lot.make_first_bid': 'Make the first bid',
    'lot.fixed_price': 'Fixed price',
    'lot.total': 'Total',
	'lot.left': 'Lots left:',
    'lot.follow': 'Track the auction',
    'lot.you_might': 'You might be interested in',
    'fund.active_auctions': 'Active auctions',
    'fund.participants_supported': 'Participants, which have already supported the foundation',
    '404.message': 'Such a page does<br />not exist',
    'partners.partners': 'Partners',
    'partners.write_us': 'If you have any suggestions for a collaboration or want to become one of our partners, write us',
    'comments_index.comments': 'Comments',
    'comments_index.more': 'Show more',
    'comments_index.leave_comment': 'Leave a comment',
    'comments_index.write_comment': 'Write a comment',
    'search.search': 'Search',
    'search.auction': 'Auction',
    'search.participant': 'Participant',
    'search.foundation': 'Foundation',
    'search.no_results': 'No results found for your search',
    'member.with_participation_of': 'With the participation of',
    'member.were_collected': 'were collected',
    'member.nothing_collected_1': 'Nothing yet has been collected with the participation of',
    'member.nothing_collected_2': '',
    'member.inform_me': 'Inform me about future auctions',
    'member.active_auction': 'Active auction',
    'member.no_active_auctions': 'There are no active auctions',
    'categories_index.all_categories': 'All categories',
    'cardlist.remove': 'remove',
    'cardlist.add': 'Add payment card',
    'regions.title': 'Select country',
    'regions.disclaimer': 'Please translate me properly "Чтобы начать делать ставки, выберите страну, с людьми из которой вы хотите встретиться"',
    'regions.setCountryPlaceholder': 'Select country',
    'regions.setLanguagePlaceholder': 'Select language',
    'regions.done': 'Done'
  },
  'ru': {
    'common.and': 'и',
    'common.bid': 'ставка',
    'common.bids_few': 'ставки',
    'common.bids_many': 'ставок',
    'common.day': 'день',
    'common.days_few': 'дня',
    'common.days_many': 'дней',
    'common.foundation_instrumental_case': 'фондом',
    'common.foundations_instrumental_case': 'фондами',
    'common.hour': 'час',
    'common.hours_few': 'часа',
    'common.hours_many': 'часов',
    'common.coming_soon': 'coming soon',
    'hero.for_charity': 'на благо&shy;тво&shy;рительность',
    'hero.good_excuse': 'Хороший повод для встречи — правильный способ помочь. Делайте ставки, выи&shy;гры&shy;вай&shy;те встречи и помогайте тем, кто в этом нуждается.',
    'profile_report.report_sent': 'Ваш отчет успешно отправлен!',
    'profile_report.report_about': 'Отчёт о встрече с',
    'profile_report.your_impressions': 'Ваши впечатления',
    'profile_report.error': 'Что-то пошло не так, попробуйте позже...',
    'profile_report.send': 'Отправить',
    'profile_report.delete_photo': 'Удалить фото',
    'profile_report.add_photo': 'Добавить фото',
    'profile_report.you_must_fill': 'Необходимо написать текст отчета',
    'profile_edit.back': 'Назад',
    'profile_edit.save': 'Сохранить',
    'profile_edit.login': 'Изменить номер телефона',
    'profile_edit.name': 'Имя',
    'profile_edit.surname': 'Фамилия',
    'profile_edit.field_required': 'Не указано значение поля',
    'profile_edit.phone_format': 'Телефон должен быть вида 7ХХХХХХХХХХ',
    'profile_edit.email_format': 'Email должен быть вида something@exxample.com',
    'profile_sidebar.you_donated': 'Вы пожертвовали',
    'profile_sidebar.you_did_not_donate': 'Вы ничего<br />не пожертво&shy;вали',
    'profile_sidebar.unpaid_lots': 'Неоплаченные лоты',
    'profile_sidebar.paid_fixedpricelots': 'Покупки фиксированных лотов',
    'profile_sidebar.pay': 'Оплатить',
    'profile_sidebar.not_won': 'Похоже, пока вы не выиграли ни одного аукциона. Время сделать победную ставку и поддержать тех, кто в этом нуждается.',
    'claim.become_participant': 'Стать участником',
    'claim.application_accepted': 'Ваша заявка принята!',
    'claim.few_words': 'Напишите пару слов о себе',
    'claim.write_about': 'Напишите о себе',
    'claim.send': 'Отправить',
    'claim.error': 'Что-то пошло не так, повторите попытку позже...',
    'select.subject': 'Тема сообщения',
    'header.auctions': 'Аукционы',
    'header.fixedprices': 'FixPrice lots',
    'header.help': 'Помочь',
    'header.foundations': 'Фонды',
    'header.participants': 'Участники',
    'header.news': 'Новости',
    'header.contacts': 'Контакты',
    'header.become_participant': 'Стать участником',
    'header.settings': 'Настройки',
    'header.profile': 'Личный кабинет',
    'header.logout': 'Выйти',
    'header.login': 'Войти',
    'timer.repeat_in': 'Мы отправили код подтверждения на указанный логин. Его можно отправить повторно через',
    'timer.resend': 'Выслать код повторно',
    'timer.back': 'Назад',
    'sidebar_share.share': 'Поделиться:',
    'sidebar_share.facebook': 'Фейсбук',
    'sidebar_share.vk': 'Вконтакте',
    'sidebar_share.twitter': 'Твиттер',
    'form.send': 'Отправить',
    'preview_list.we_have': 'Мы сотрудничаем с',
    'preview_list.among_them': 'среди них',
    'preview_list.see_all': 'Посмотреть все фонды',
    'bid_history.you': 'Вы',
    'bid_history.show_more': 'Показать ещё',
    'bid.bid_sent': 'Операция осуществлена успешно!', //Ваша ставка успешно отправлена
    'bid.bid_na': 'Ставки недоступны',
    'bid.make_bid': 'Сделать ставку',
	'bid.make_purchase': 'Совершить покупку',
    'bid.login_required': 'Сначала войдите в свой аккаунт',
    'bid.bid': 'Ставка',
    'bid.error': 'Что-то пошло не так, попробуйте позже...',
    'bid.make_bid_anonymously': 'Сделать ставку анонимно',
    'bid.follow_auction': 'Отслеживать аукцион',
    'bid.choose_bid': 'Укажите вашу ставку',
    'bid.choose_payment_method': 'Выберите способ оплаты',
    'bid.bid_too_small': 'Ваша ставка не может быть ниже',
    'bid.agreement_title': 'Уважаемый пользователь!',
    'bid.proceed': 'Продолжить',
    'bid.select_payment': 'Выберите метод оплаты',
    'bid.make_payment': 'Сделать пожертвование',
    'bid.select_card': 'Выберите карту',
    'bidPayment.confirm_delete_card': 'Вы действительно хотите удалить привязанную карту?',
    'bidPayment.add': 'Добавить карту',
    'bidPayment.remove': 'Удалить',
    'bidPayment.activated': 'Подключено',
    'lot_sidebar.profile': 'Профиль',
    'lot_sidebar.on_facebook': 'в Фейсбуке',
    'person.tell_us': 'Расскажите<br />о встрече',
    'person.expiration': 'До завершения',
    'person.overbid': 'Вашу ставку перебили',
    'person.leading_bid': 'Ваша ставка лидирует',
    'person.place_bid': 'Сделать ставку',
    'contacts_form.message_sent': 'Ваше сообщение отправлено!',
    'contacts_form.write_message': 'Написать сообщение',
    'contacts_form.name': 'Имя',
    'contacts_form.email_or_phone': 'Почта или телефон',
    'contacts_form.message': 'Сообщение',
    'contacts_form.error': 'Что-то пошло не так, повторите попытку позже...',
    'preview_list.see_all_news': 'Посмотреть все новости',
	'fixedlot.place_order': 'Купить лот',//'Назначить встречу',
	'fixedlot.expert_text': 'Данные лоты доступны по фиксированной стоимости',
    'fund_donation_container.participants_supported': 'Участники, которые уже поддержали фонд',
    'fund_donation_container.show_more': 'Показать ещё',
    'fund_donation.may_26': '26 мая',
    'fund_donation_stats.amount': 'В пользу фонда собрано',
    'fund_donation_stats.no_funds': 'Пока ничего не собрано в пользу фонда',
    'mobile_menu.auctions': 'Аукционы',
    'mobile_menu.fixedprices': 'FixPrice lots',
    'mobile_menu.help': 'Помочь',
    'mobile_menu.foundations': 'Фонды',
    'mobile_menu.participants': 'Участники',
    'mobile_menu.news': 'Новости',
    'mobile_menu.contacts': 'Контакты',
    'mobile_menu.become_participant': 'Стать участником',
    'mobile_menu.settings': 'Настройки',
    'mobile_menu.logout': 'Выход',
    'mobile_menu.login': 'Вход',
    'payment_fallback.success': 'Оплата лота прошла успешно!',
    'payment_fallback.home': 'На главную',
    'payment_fallback.foundation': 'Фонд',
    'payment_fallback.sum': 'Сумма пожертвования',
    'payment_callback.heading': 'Заголовок',
    'payment_callback.email': 'Ваш Email',
    'payment_callback.enter_email': 'Введите свой контактный email адрес',
    'payment_callback.email_format': 'Неверный формат email адреса',
    'payment_form.pay': 'Оплатить',
    'payment_error.error': 'Возникла ошибка при внесении пожертвования',
    'payment_error.try_again': 'Повторить',
    'footer.offer': 'Оферта',
    'footer.about': 'О нас',
    'footer.user_agreement': 'Пользовательское соглашение',
    'footer.auctions': 'Аукционы',
    'footer.fixedprices': 'Fix price lots',
    'footer.foundations': 'Фонды',
    'footer.participants': 'Участники',
    'footer.news': 'Новости',
    'footer.contacts': 'Контакты',
    'footer.partners': 'Партнеры',
    'footer.we_are_on': 'Мы в',
    'footer.facebook': 'Фейсбуке',
    'footer.instagram': 'Инстаграме',
    'footer.twitter': 'Твиттере',
    'footer.youtube': 'YouTube',
    'footer.subscription_success': 'Подписка оформлена!',
    'footer.subscribe': 'Подписаться на новости',
    'about.about': 'О нас',
    'sign_in.login': 'Вход',
    'sign_in.mail': 'Email',
    'sign_in.phone': 'Телефон',
    'sign_in.phone_or_mail': 'Ваш номер телефона',
    'sign_in.confirmation_code': 'Код подтверждения',
    'sign_in.name': 'Имя',
    'sign_in.surname': 'Фамилия',
    'sign_in.by_pressing': 'Нажимая далее, я принимаю условия',
    'sign_in.user_agreement': 'Пользовательского соглашения',
    'sign_in.and_give_permission': 'и даю согласие на обработку моей персональной информации',
    'profile.meet': 'Встретиться',
    'profile.auctions_won': 'Выигранные аукционы',
    'profile.organize_meeting': 'Договариваемся о встрече',
    'profile.tell_about_meeting': 'Рассказать о встрече',
    'profile.meetings': 'Ваши встречи',
    'profile.win_meeting': 'Выиграйте встречу своей мечты',
    'profile.choose_auction': 'Выберите аукцион с интересующим вас человеком и сделайте ставку.',
    'profile.see_auctions': 'Посмотреть аукционы',
    'profile.active_auctions': 'Активные аукционы',
    'profile.bid_history': 'История ставок',
    'static.last_modified': 'Дата последнего изменения',
    'contacts.address': 'Москва, Новая площадь, 6',
    'contacts.we_are_on': 'Мы в',
    'contacts.facebook': 'Фейсбуке',
    'contacts.instagram': 'Инстаграме',
    'contacts.twitter': 'Твиттере',
    'contacts.youtube': 'YouTube',
    'contacts.if_you_have': 'Если у вас есть вопросы о работе сайта, приложения, механике аукционов, лотах или любой другой вопрос, напишите нам:',
    'contacts.write': 'Написать',
    'home.see_all_auctions': 'Посмотреть все аукционы',
    'pay.pay': 'По реквизитам',
    'pay.card': 'Оплатить банковской картой',
    'pay.do_payment': 'Оплатить',
    'members.more': 'Посмотреть ещё',
    'lot_list_index.loading': 'Загрузка',
    'lot_list_index.more': 'Посмотреть ещё',
    'funds.collected': 'собрано',
    'funds.more': 'Показать ещё',
    'lot.last_bid': 'Последняя ставка',
    'lot.raise_bid': 'Поднять ставку',
    'lot.place_bid': 'Сделать ставку',
    'lot.make_first_bid': 'Сделайте ставку первым',
    'lot.fixed_price': 'Фиксированная цена',
    'lot.total': 'Всего',
	'lot.left': 'Осталось свободных лотов:',
    'lot.follow': 'Cледить за аукционом',
    'lot.you_might': 'Вас могут заинтересовать',
    'fund.active_auctions': 'Активные аукционы',
    'fund.participants_supported': 'Участники, которые уже поддержали фонд',
    '404.message': 'такой страницы не<br />существует',
    'partners.partners': 'Партнеры',
    'partners.write_us': 'Если у вас есть предложения о сотрудничестве или вы хотите стать нашим партнером, напишите нам',
    'comments_index.comments': 'Комментарии',
    'comments_index.more': 'Показать ещё',
    'comments_index.leave_comment': 'Оставить комментарий',
    'comments_index.write_comment': 'Написать комментарий',
    'search.search': 'Поиск',
    'search.auction': 'Аукцион',
    'search.participant': 'Участник',
    'search.foundation': 'Фонд',
    'search.no_results': 'По вашему запросу ничего не найдено',
    'member.with_participation_of': 'C участием',
    'member.were_collected': 'собрано',
    'member.nothing_collected_1': 'C участием',
    'member.nothing_collected_2': 'пока ничего не собрано',
    'member.inform_me': 'Сообщить о будущих аукционах',
    'member.active_auction': 'Active auction',
    'member.no_active_auctions': 'Нет активных аукционов',
    'categories_index.all_categories': 'Все категории',
    'cardlist.remove': 'удалить',
    'cardlist.add': 'Добавить карту',
    'regions.title': 'Выбор страны',
    'regions.disclaimer': 'Чтобы начать делать ставки, выберите страну, с людьми из которой вы хотите встретиться',
    'regions.setCountryPlaceholder': 'Выберите страну',
    'regions.setLanguagePlaceholder': 'Выберите язык',
    'regions.done': 'Готово'
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/i18n/data.js